// extracted by mini-css-extract-plugin
export default {"course":"Course_course__+FMAa","identicon":"Course_identicon__J60xu"};